import { ProgressSpinner } from 'primereact/progressspinner'
import { classNames } from 'primereact/utils'
import { useAppSelector } from '../../store'
import './LoadingComponent.scss'

const LoadingComponent: React.FC = () => {
  const { loadingCounter } = useAppSelector((state) => state.layout)

  return (
    <div className={classNames('general-loading-spinner', { hidden: loadingCounter <= 0 })}>
      <ProgressSpinner style={{ width: '75px', height: '75px' }} strokeWidth="5" animationDuration=".6s" />
    </div>
  )
}

export default LoadingComponent
